export const listStyles = {
  ordinary: ['', 'lower-alpha', 'disc'],
  aggregate: ['', '', 'number'],
};
